// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a26460b3","942":"aeaf74bd"}[chunkId] + ".chunk.js";
};